export function getDownloadUserGuideUrl(instance: string, language: string){
    const env = instance === 'neuprod' ? 'EU' : instance === 'ejpprod' ? 'JA' : 'US';
    const urlkey = `REACT_APP_USER_GUIDE_${env}_${language.toLocaleUpperCase()}_URL`
    const url = process.env[urlkey] as string;

    return url || process.env.REACT_APP_USER_GUIDE_URL as string;
  }
  export function getDownloadCamReadinessGuideUrl(instance: string, language: string){
    const env = instance === 'neuprod' ? 'EU' : instance === 'ejpprod' ? 'JA' : 'US';
    const urlkey = `REACT_APP_SECOND_CAMERA_READINESS_GUIDE_${env}_${language.toLocaleUpperCase()}_URL`
    const url = process.env[urlkey] as string;

    return url || process.env.REACT_APP_SECOND_CAMERA_READINESS_GUIDE_URL as string;
  }
 export function getSecondCameraVideoUrl(language: string): string {
  const urlKey = `REACT_APP_SECOND_CAMERA_VIDEO_${language.toLocaleUpperCase()}_URL`;
  const url = process.env[urlKey] as string;
  const match = url.match(/\/embed\/(?:iframe\/|medias\/)([^?#]+)/);
  
  return match ? match[1] : '';
}

/**
 * @function isMobileDevice
 * @description Detects if the current device is a mobile phone, tablet, or a similar touch-based device
 * by checking the user agent string.
 * @returns {boolean} True if a mobile device is detected, otherwise false.
 */
export function isMobileDevice(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

    // List of keywords to check for in the user agent string
    const mobileKeywords = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /IEMobile/i,
        /Opera Mini/i,
    ];

    return mobileKeywords.some(keyword => userAgent.match(keyword));
};

export const sleep = (ms?: number): Promise<void> => {
  if (!ms) ms = parseInt(process.env.REACT_APP_SYSTEM_CHECK_DELAY_MS ?? '2000', 10);
  return new Promise((resolve) => setTimeout(resolve, ms));
};
